import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const empty = { oldpassword: "", password: "", confirm: "" };

// `renderTrigger(open)` lets a caller (e.g. the sidebar) supply its own clickable
// element; without it the default header-dropdown button is rendered.
function ChangePassword({ renderTrigger }) {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const close = () => {
    setShow(false);
    setForm(empty);
    setError("");
  };

  const onChange = (key) => (e) =>
    setForm((prev) => ({ ...prev, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.oldpassword) return setError("Enter your current password.");
    if (form.password.length < 8)
      return setError("New password must be at least 8 characters.");
    if (form.password !== form.confirm)
      return setError("New password and confirmation do not match.");
    if (form.password === form.oldpassword)
      return setError("New password must differ from the current one.");

    try {
      setSaving(true);
      await axios.post(`${API_BASE_URL}/api/change-password`, {
        oldpassword: form.oldpassword,
        password: form.password,
      });
      close();
      Swal.fire({
        icon: "success",
        title: "Password changed",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (err) {
      const data = err?.response?.data;
      setError(
        data?.message ||
          data?.errors?.[0]?.msg ||
          "Could not change password. Try again.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {renderTrigger ? renderTrigger(() => setShow(true)) : (
      <button
        type="button"
        className="dropdown-item ai-icon d-flex align-items-center"
        onClick={() => setShow(true)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={18}
          style={{ flexShrink: 0 }}
          height={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span className="ms-2">Change Password</span>
      </button>
      )}

      <Modal show={show} onHide={close} centered>
        <form onSubmit={onSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <div className="mb-3">
              <label className="form-label">Current password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="current-password"
                value={form.oldpassword}
                onChange={onChange("oldpassword")}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">New password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={form.password}
                onChange={onChange("password")}
              />
              <small className="text-muted">At least 8 characters.</small>
            </div>
            <div className="mb-1">
              <label className="form-label">Confirm new password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={form.confirm}
                onChange={onChange("confirm")}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-light" onClick={close}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Update Password"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default ChangePassword;
